import { sanitizeGameIds } from '../../../api/utils/sanitizeGameIds'
import type { Game } from '../../game/types/Game'

export const SLACK_PREFERENCE_GAMES_INCLUDE = 'name,names,icon,icons'

export const gameIdsFromSelectedGames = (games: Array<Pick<Game, 'id'> | null | undefined> = []): string[] => {
  return sanitizeGameIds(games.map((game) => game?.id))
}
